// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"269":"a93372c0","298":"f68fc8c1","387":"e3df632b","904":"d36c8ca7"}[chunkId] + ".chunk.js";
};